<template>
	<div v-parallax-fit="parallax" class="map">
		<img v-parallax-fit="map_1" class="map-1"
			src="/themes/rise-theme/dist/images/estate/character-view/holly/26_Map_01.png" alt="">
		<img v-parallax-fit="map_2" class="map-2"
			src="/themes/rise-theme/dist/images/estate/character-view/holly/27_Map_02.png" alt="">
		<img class="map-3" src="/themes/rise-theme/dist/images/estate/character-view/holly/27_Map_03.png" alt="">

		<div class="hand-1 hand">
			<img v-parallax-fit="hand_1"
				src="/themes/rise-theme/dist/images/estate/character-view/holly/23_PuzzleHand_0_1@2x.png" alt="">
		</div>
		<div class="hand-2 hand">
			<img v-parallax-fit="hand_2"
				src="/themes/rise-theme/dist/images/estate/character-view/holly/24_PuzzleHand_02.png" alt="">
		</div>
		<div class="hand-3 hand">
			<img v-parallax-fit="hand_3"
				src="/themes/rise-theme/dist/images/estate/character-view/holly/25_PuzzleHand_03.png" alt="">
		</div>

		<div class="puzzle-1 puzzle">
			<img v-parallax-fit="puzzle_1"
				src="/themes/rise-theme/dist/images/estate/character-view/holly/23_PuzzlePiece_01.png" alt="">
		</div>
		<div class="puzzle-2 puzzle">
			<img v-parallax-fit="puzzle_2"
				src="/themes/rise-theme/dist/images/estate/character-view/holly/24_PuzzlePiece_02.png" alt="">
		</div>
		<div class="puzzle-3 puzzle">
			<img v-parallax-fit="puzzle_3"
				src="/themes/rise-theme/dist/images/estate/character-view/holly/25_PuzzlePiece_03.png" alt="">
		</div>

		<div class="arrow">
			<div v-parallax-fit="arrow" ref="arrow1">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
			<div v-parallax-fit="arrow">
				<img class="rent-increase"
					src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/holly/4.srt',
				'es': '/themes/rise-theme/resources/assets/audio/holly/4_es.srt'
			},
			mutationObserver: null,
			mutationObserver2: null,
			parallax: [
				{
					start: 18400,
					end: 19200,
					fromStyle: { transform: 'translateX(-45%) translateY(-300%) rotate(0deg)' },
					toStyle: { transform: 'translateX(-45%) translateY(-50%) rotate(2deg)' },
					easing: 'linear'
				},
				{
					start: 22000,
					end: 23000,
					fromStyle: { transform: 'translateX(-45%) translateY(-51%) rotate(2deg)' },
					toStyle: { transform: 'translateX(-45%) translateY(300%) rotate(2deg)' },
					easing: 'linear'
				}
			],
			hand_1: [
				{
					start: 18400,
					end: 19200,
					fromStyle: { transform: 'translateX(-100%) translateY(-100%)' },
					toStyle: { transform: 'translateX(0%) translateY(0%)' },
					easing: 'linear'
				},
				{
					start: 20500,
					end: 21500,
					fromStyle: { transform: 'translateX(0%) translateY(0%)' },
					toStyle: { transform: 'translateX(-100%) translateY(-100%)', opacity: 0 },
					easing: 'linear'
				}
			],
			hand_2: [
				{
					start: 18400,
					end: 19200,
					fromStyle: { transform: 'translateX(100%) translateY(-100%)' },
					toStyle: { transform: 'translateX(0%) translateY(0%)' },
					easing: 'linear'
				},
				{
					start: 20500,
					end: 21500,
					fromStyle: { transform: 'translateX(0%) translateY(0%)' },
					toStyle: { transform: 'translateX(100%) translateY(-100%)', opacity: 0 },
					easing: 'linear'
				}
			],
			hand_3: [
				{
					start: 18400,
					end: 19200,
					fromStyle: { transform: 'translateX(200%) translateY(250%)' },
					toStyle: { transform: 'translateX(0%) translateY(0%)' },
					easing: 'linear'
				},
				{
					start: 20500,
					end: 21500,
					fromStyle: { transform: 'translateX(0%) translateY(0%)' },
					toStyle: { transform: 'translateX(200%) translateY(250%)' },
					easing: 'linear'
				}
			],
			puzzle_1: [
				{
					start: 18400,
					end: 19200,
					fromStyle: { transform: 'translateX(-270%) translateY(-420%)' },
					toStyle: { transform: 'translateX(0%) translateY(0%)' },
					easing: 'linear'
				}
			],
			puzzle_2: [
				{
					start: 18400,
					end: 19200,
					fromStyle: { transform: 'translateX(270%) translateY(-420%)' },
					toStyle: { transform: 'translateX(0%) translateY(0%)' },
					easing: 'linear'
				}
			],
			puzzle_3: [
				{
					start: 18400,
					end: 19200,
					fromStyle: { transform: 'translateX(700%) translateY(1150%)' },
					toStyle: { transform: 'translateX(0%) translateY(0%)' },
					easing: 'linear'
				}
			],
			map_1: [
				{
					start: 19500,
					end: 20000,
					fromStyle: { opacity: 1 },
					toStyle: { opacity: 0 },
					easing: 'linear'
				}
			],
			map_2: [
				{
					start: 20000,
					end: 20500,
					fromStyle: { opacity: 1 },
					toStyle: { opacity: 0 },
					easing: 'linear'
				}
			],
			arrow: [
				{
					start: 20500,
					end: 21000,
					fromStyle: { width: '0%' },
					toStyle: { width: '110%' },
					easing: 'linear'
				}
			]
		}
	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/holly/4.mp3';

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateX(-45%) translateY(-50%) rotate(2deg)') {
					self.$audioUrl.value = audio;
					self.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					self.$evidence.value = null;
					self.$readMore.value = '';
				}
			});
		});

		this.mutationObserver.observe(document.querySelector('.map'), {
			attributes: true,
			attributeFilter: ['style']
		});

		const evidence2 = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/14.png',
					url: 'https://www.manufacturedhomepronews.com/wp-content/uploads/2021/06/MHAction-DIsplacement-Inc-HavenparkCapitalWarrenBuffettManufacturedHousingInstituteMHProNewsFactCheck.pdf',
					link_title: {
						'en': "Displacement, Inc.",
						'es': 'Desplazamiento, Inc.'
					},
				}
			],
			text: {
				'en': '"...How could Enterprise, Bellwether, and Fannie Mae claim this financing is preserving affordable housing? How could they let these loans be captured by private equity groups to raise rents, receive big payouts, and push out the most vulnerable tenants?” questioned Matt from Waukee, Iowa.',
				'es': '"... ¿Cómo podrían Enterprise, Bellwether y Fannie Mae afirmar que este financiamiento está preservando viviendas asequibles? ¿Cómo podrían permitir que estos préstamos sean capturados por grupos de capital privado para aumentar los alquileres, recibir grandes pagos y expulsar a los inquilinos más vulnerables?" preguntó Matt de Waukee, Iowa.'
			}
		};
		const text2 = {
			'en': "Havenpark has purchased many of their new acquisitions using federally-backed, low-interest loans from Fannie Mae, meaning the federal government is effectively subsidizing the corporate takeover of this part of the housing market.",
			'es': 'Havenpark ha comprado muchas de sus nuevas adquisiciones utilizando préstamos a bajo interés respaldados por el gobierno federal de Fannie Mae, lo que significa que el gobierno federal está subsidiando efectivamente la adquisición corporativa de esta parte del mercado inmobiliario.'
		};

		this.mutationObserver2 = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.width == '110%') {
					self.$evidence.value = JSON.stringify(evidence2);
					self.$readMore.value = text2;
				}
			});
		});

		this.mutationObserver2.observe(this.$refs.arrow1, {
			attributes: true,
			attributeFilter: ['style']
		});

	},
	unmounted() {
		this.mutationObserver.disconnect();
		this.mutationObserver2.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.map {
	position: absolute;
	top: 50%;
	left: 50%;
	max-width: 1100px;
	min-width: 1100px;
	transition: all 0.1s linear;

	.arrow {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		z-index: 3;
		display: grid;
		grid-template-columns: 15% 15% 15% 15%;
		grid-gap: 0 4%;
		justify-content: center;
		transform: rotate(1deg);

		div {
			width: 0;
			overflow: hidden;
			transition: all 0.1s linear;
			position: relative;

			img {
				min-width: 175px;
				display: block;
			}
		}

		div:nth-child(1) {
			top: 90%;
		}

		div:nth-child(2) {
			top: 70%;
		}

		div:nth-child(3) {
			top: 80%;
		}

		div:nth-child(4) {
			top: 70%;
		}

		div:nth-child(5) {
			left: 15%;
			top: 50%;
		}

		div:nth-child(6) {
			left: -5%;
			top: 50%;
		}

		div:nth-child(7) {
			left: 15%;
			top: 30%;
		}

		div:nth-child(8) {
			left: -7%;
			top: 30%;
		}

		div:nth-child(9) {
			top: 20%;
		}

		div:nth-child(10) {
			left: 15%;
			top: 50%;
		}

		div:nth-child(11) {
			left: 60%;
			top: 10%;
		}

		div:nth-child(12) {
			left: -10%;
			top: 50%;
		}

		div:nth-child(13) {
			left: 30%;
			top: -30%;
		}
	}

	.map-1 {
		position: relative;
		z-index: 3;
	}

	.map-2 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
	}

	.map-3 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
	}

	.hand,
	.puzzle {
		position: absolute;
	}

	.hand {
		z-index: 5;
	}

	.puzzle {
		z-index: 4;
	}

	.hand-1 {
		bottom: 50%;
		left: -8%;
		max-width: 600px;
	}

	.hand-2 {
		bottom: 52%;
		right: -4%;
		max-width: 600px;
	}

	.hand-3 {
		top: 51%;
		right: -18%;
		max-width: 750px;
	}

	.puzzle-1 {
		top: 32%;
		left: 33%;
		max-width: 220px;
	}

	.puzzle-2 {
		top: 27%;
		right: 34.5%;
		max-width: 220px;
	}

	.puzzle-3 {
		bottom: 27.6%;
		right: 38.5%;
		max-width: 220px;
	}
}

@media screen and (max-width: 1600px) {
	.map {
		max-width: 900px;
		min-width: 900px;

		.arrow {
			div {
				img {
					min-width: 141px;
				}
			}
		}

		.hand-1 {
			bottom: 50%;
			left: -4%;
			max-width: 450px;
		}

		.hand-2 {
			bottom: 53%;
			right: 2%;
			max-width: 450px;
		}

		.hand-3 {
			top: 47%;
			right: -13%;
			max-width: 585px;
		}

		.puzzle-1 {
			max-width: 170px;
		}

		.puzzle-2 {
			right: 36.5%;
			max-width: 170px;
		}

		.puzzle-3 {
			bottom: 30%;
			right: 40%;
			max-width: 170px;
		}
	}
}

@media screen and (max-width: 1024px) {
	.map {
		max-width: 800px;
		min-width: 800px;

		.arrow {
			div {
				img {
					min-width: 126px;
				}
			}
		}

		.hand-1 {
			bottom: 55%;
			left: -2%;
			max-width: 350px;
		}

		.hand-2 {
			bottom: 56%;
			right: 13%;
			max-width: 350px;
		}

		.hand-3 {
			top: 44%;
			right: 0%;
			max-width: 450px;
		}

		.puzzle-1 {
			top: 30%;
			left: 30%;
			max-width: 130px;
		}

		.puzzle-2 {
			right: 43.5%;
			top: 26.4%;
			max-width: 130px;
		}

		.puzzle-3 {
			bottom: 37.5%;
			right: 46.6%;
			max-width: 130px;
		}
	}
}

@media screen and (max-width: 650px) {
	.map {
		max-width: 350px;
		min-width: 350px;

		.arrow {
			div {
				img {
					min-width: 55px;
				}
			}
		}

		.hand-1 {
			bottom: 53%;
			left: -26%;
			max-width: 250px;
		}

		.hand-2 {
			bottom: 57%;
			right: -19%;
			max-width: 250px;
		}

		.hand-3 {
			top: 45%;
			right: -38%;
			max-width: 305px;
		}

		.puzzle-1 {
			top: 23%;
			left: 27%;
			max-width: 90px;
		}

		.puzzle-2 {
			right: 31%;
			top: 16%;
			max-width: 90px;
		}

		.puzzle-3 {
			bottom: 25%;
			right: 36%;
			max-width: 90px;
		}
	}
}
</style>
